import { IFinancialTableData } from './financial-table-data.interface';
import { INotesMovementScheduleData } from './notes-movement-schedule-data.interface';
import { INotesTableData } from './notes-table-data.interface';
import { SuperTableStructuredData } from './super-table-structured-data.interface';

export interface IItem {
    componentId?: string;
    itemType: string;
    data: IFinancialTableData[] | string | INotesTableData[] | INotesMovementScheduleData[];
    tables?: IFinancialTableData[][] | INotesMovementScheduleData[][];
    componentTitle?: string;
    superTableStructuredDataForExcelExport?: SuperTableStructuredData;
    amountOfRows?: number;
    /**
     * FX (REV-21512): set on an FX report's items so the print layer can pick its table format
     * up front, without inspecting cells. Its date headers carry the column currency on a second
     * line, and `both` additionally fills cV2/pV2. Absent on every non-FX report.
     */
    isFxFormat?: boolean;
}
